import React, { useState, useEffect } from 'react';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import './App.css';

function App() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };

    window.addEventListener('popstate', handleLocationChange);
    
    // Custom event to handle link clicks since we don't have react-router
    window.addEventListener('navigate', (e) => {
      window.history.pushState({}, '', e.detail);
      setCurrentPath(e.detail);
    });

    return () => {
      window.removeEventListener('popstate', handleLocationChange);
      window.removeEventListener('navigate', handleLocationChange);
    };
  }, []);

  const renderPage = () => {
    switch (currentPath) {
      case '/':
        return <Home />;
      case '/about':
        return <About />;
      case '/products':
        return <Products />;
      case '/privacy':
        return <Privacy />;
      case '/terms':
        return <Terms />;
      default:
        return <Home />;
    }
  };

  // We add conditional logic so that the Home page doesn't get .page-content wrapping automatically
  // Because Home has its own full-width .home-container.
  // Actually, wait, .page-content was inside renderPage components originally except for the App wrapper.
  // Let's check how the wrapper is structured.
  // Wait, I removed `.page-content` from Home and replaced it with `.home-container`. 
  // It should just render fine.

  return (
    <div className="App">
      <Navigation />
      {renderPage()}
      <Footer />
    </div>
  );
}

export default App;